// extracted by mini-css-extract-plugin
export default {"CallToAction__Section":"CallToAction_CallToAction__Section__dATkG","Card":"CallToAction_Card__Q2RpW","Title":"CallToAction_Title__93rW6"};